import { formatCurrency as sharedFormatCurrency } from '@/shared/utils/formatter';
import type { BasicInfoField } from '../types/riderInfoDetail.types';
import {
    ACCOUNT_NUMBER_VALIDATION,
    ACCOUNT_HOLDER_VALIDATION,
    BANK_VALIDATION,
} from '../constants/riderInfoDetail.constants';

export const DEDUCTION_TABLE_COLUMNS = [
    'NO',
    '공제이름',
    '공제금액',
    '시작일자',
    '종료일자',
] as const;

export const DEDUCTION_COLUMN_COUNT = DEDUCTION_TABLE_COLUMNS.length;

export const BASIC_INFO_LEFT_FIELDS: BasicInfoField[] = [
    { label: '협력사명', key: 'supplierName' },
    { label: '이름', key: 'name' },
    { label: '아이디', key: 'id' },
    { label: '계약상태', key: 'contractStatus' },
    { label: '주민등록번호', key: 'residentNumber' },
    { label: '등록일', key: 'registrationDate' },
];

export const BASIC_INFO_RIGHT_FIELDS: BasicInfoField[] = [
    { label: '협력사ID', key: 'supplierId' },
    { label: '휴대폰 번호', key: 'phone' },
    { label: '생년월일', key: 'birthDate' },
    { label: '배달수단', key: 'deliveryMethod' },
    { label: '계약종료일', key: 'contractEndDate' },
    { label: '정산여부', key: 'currentSettlement' },
    { label: '정산변경예정', key: 'nextSettlement' },
];

export const formatCurrency = (value: number | undefined): string => {
    if (value === undefined || value === null) return '-';
    return sharedFormatCurrency(value);
};

export const getDisplayValue = (value: string | null | undefined): string => {
    return value || '-';
};

export const formatSettlementDate = (value: string | null | undefined): string => {
    if (!value || value.length !== 8) return '-';
    return `${value.slice(0, 4)}-${value.slice(4, 6)}-${value.slice(6, 8)}`;
};

export const sanitizeAccountNumber = (value: string): string => {
    return value.replace(/[^0-9]/g, '');
};

export const sanitizeAccountHolder = (value: string): string => {
    const sanitized = value.replace(/[^가-힣ㄱ-ㅎㅏ-ㅣa-zA-Z\s]/g, '');
    return sanitized.slice(0, ACCOUNT_HOLDER_VALIDATION.MAX_LENGTH);
};

export const validateAccountInfo = (
    bank: string,
    accountNumber: string,
    accountHolder: string,
): string | null => {
    if (!bank || bank.trim() === '') return BANK_VALIDATION.ERROR_MESSAGES.REQUIRED;

    if (!accountNumber || accountNumber.trim() === '')
        return ACCOUNT_NUMBER_VALIDATION.ERROR_MESSAGES.REQUIRED;

    if (
        accountNumber.length < ACCOUNT_NUMBER_VALIDATION.MIN_LENGTH ||
        accountNumber.length > ACCOUNT_NUMBER_VALIDATION.MAX_LENGTH
    ) {
        return ACCOUNT_NUMBER_VALIDATION.ERROR_MESSAGES.INVALID_LENGTH;
    }

    if (!accountHolder || accountHolder.trim() === '')
        return ACCOUNT_HOLDER_VALIDATION.ERROR_MESSAGES.REQUIRED;

    if (accountHolder.length < ACCOUNT_HOLDER_VALIDATION.MIN_LENGTH)
        return ACCOUNT_HOLDER_VALIDATION.ERROR_MESSAGES.INVALID_LENGTH;

    return null;
};
